module.exports = __webpack_public_path__ + "cv.85c9d58795b36699d19c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cv.svg
// module chunks = styles